import React from "react";
import Styled from "styled-components";
import { AiFillHome } from "react-icons/ai";
import { FaUserAlt } from "react-icons/fa";
import { BsFillBriefcaseFill } from "react-icons/bs";
import { BiEnvelopeOpen } from "react-icons/bi";
import { NavLink as Link} from "react-router-dom";

function Navbar() {
  const handleMouseOver = (e) => {
    let ele1 = e.target.children[0];
    let size = window.matchMedia("(max-width:768px)");
    if (size.matches) {
      ele1.childNodes[0].style.display = "none";
      ele1.style.paddingLeft = "0";
      ele1.style.backgroundColor = "#ffb400";
    } else {
      ele1.childNodes[0].style.display = "flex";
      ele1.style.width = "fit-content";
      ele1.style.paddingLeft = "10px";
      ele1.style.backgroundColor = "#ffb400";
    }
  };
  const handleMouseLeave = (e) => {
    let ele1 = e.target.children[0];
    let size = window.matchMedia("(max-width:768px");
    if (size.matches) {
      ele1.childNodes[0].style.display = "none";
      ele1.style.paddingLeft = "0";
      ele1.style.backgroundColor = "transparent";
    } else {
      ele1.childNodes[0].style.display = "none";
      ele1.style.width = "fit-content";
      ele1.style.paddingLeft = "0px";
      ele1.style.backgroundColor = "transparent";
    }
  };
  return (
    <Nav>
      <ul>
        <NavLink
          to="/"
          activeStyle
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          <Extend className="nav-item">
            <span style={{ display: "none" }}>Home</span>
            <Colapse className="nav-item-colapse">
              <AiFillHome />
            </Colapse>
          </Extend>
        </NavLink>
        <NavLink
          to="/about"
          activeStyle
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          <Extend className="nav-item">
            <span style={{ display: "none" }}>About</span>
            <Colapse className="nav-item-colapse">
              <FaUserAlt />
            </Colapse>
          </Extend>
        </NavLink>
        <NavLink
          to="/project"
          activeStyle
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          <Extend>
            <span style={{ display: "none" }}>Projects</span>
            <Colapse>
              <BsFillBriefcaseFill />
            </Colapse>
          </Extend>
        </NavLink>
        <NavLink
          to="/contact"
          activeStyle
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          <Extend>
            <span style={{ display: "none" }}>Contact</span>
            <Colapse style={{background:"transparent"}}>
              <BiEnvelopeOpen style={{background:"transparent"}} />
            </Colapse>
          </Extend>
        </NavLink>
      </ul>
    </Nav>
  );
}
const NavLink = Styled(Link)`
display:flex;
justify-content:end;
z-index:20;
cursor:pointer;
height:50px;
width:50px;
text-decoration:none;
border-radius:50%;
background:#444444;
&:hover{
  background:#ffb400;
}
&.active{
  background:#ffb400;
}
`;
const Nav = Styled.div`
    position:fixed;
    right:30px;
    height:100vh;
    z-index:11;
    display:flex;
    ul{
        margin-top:15vh;
        display:flex;
        justify-content:space-around;
        height:55%;
        flex-direction:column;
        list-style:none;
        @media (max-width: 768px){
          flex-direction:row;
          margin:0;
          width:100%;
        }
    }
    @media (max-width: 768px){
      bottom:0px;
      padding:10px;
      flex-direction:row;
      width:100vw;
      height:fit-content;
      justify-content:center;
      background:#2B2A2A;
      right:0;
    }
`;
const Extend = Styled.span`
  color:black;
  border-radius:100px;
  height:50px;
  width:fit-content;
  justify-content:center;
  align-items:center;
  line-height:30px;
  display:flex;
  font-weight:600;
  text-transform:uppercase;
  position:relative;
  color:white;
  z-index:11;
  transition:all .4s;
  cursor:pointer;
  pointer-events:none;
  `;
const Colapse = Styled.span`
border-radius:50%;
  height:50px;
  width:50px;
  z-index:11;
  justify-content:center;
  align-items:center;
  display:flex;
  position:relative;
  color:white;
  pointer-events:none;
  cursor:pointer;
`;
export default Navbar;
